export const defaultTraining = {
  id: "",
  background_img: null,
  category_id: null,
  calories: null,
  category_name: null,
  code: null,
  contents: null,
  contents_version: null,
  created_at: null,
  distance: null,
  genre_name: null,
  explain: null,
  level: null,
  max_incline: null,
  level_name: null,
  max_speed: null,
  name: null,
  no: null,
  popular_no: null,
  trainer_icon: null,
  trainer_introduction: null,
  trainer_id: null,
  trainer_name: null,
  updated_at: null,
  training_time: null,
  training_type: null,
  video_count: null,
}

export const defaultVideoUrl = []

export const swiperParams = {
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
    clickable: true,
  },
  spaceBetween: 500,
}
